"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Tbody = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const Box_1 = require("../Box");
function Tbody(props) {
    return jsx_runtime_1.jsx(Box_1.Box, Object.assign({ as: "tbody" }, props), void 0);
}
exports.Tbody = Tbody;
//# sourceMappingURL=index.js.map